<template>
  <div>Xush kelibsiz</div>
</template>

<script>
export default {
  methods: {},
};
</script>
